import { Step } from "../types/Step";

export const stepPath = {
  [Step.COSA]: "/cosa",
  [Step.SCONTO]: "/sconto-finanziamento",
};
